export default {
      id: "video-event_right-turn-while-accelerating-usage",
      viewBox: "0 0 16 20",
      url: __webpack_public_path__ + "img/icons.svg#video-event_right-turn-while-accelerating",
      toString: function () {
        return this.url;
      }
    }